import numeral from "numeral";

const formatSequencial = (value: number): string => numeral(value).format("0o");

export const formatPoints = (value: number): string =>
  numeral(value).format("0,0");

export default formatSequencial;
